module.exports = __webpack_public_path__ + "static/scale-model-of-evel-knievel-museum-in-topeka-kansas-5015232a591721c7bdb3bd5012cea53c.png";